{
  "name": "console",
  "version": "0.0.0",
  "source": "src/index.html",
  "scripts": {
    "build": "parcel build",
    "dev": "npm run start:wsl",
    "lint": "eslint .",
    "start": "parcel dev/index.html",
    "start:wsl": "PARCEL_WATCHER_BACKEND=brute-force parcel dev/index.html --no-cache --host 0.0.0.0 --port 1234 --hmr-host dev-console.bimproject.cloud"
  },
  "dependencies": {
    "@apollo/client": "4.1.6",
    "@auth0/auth0-react": "2.15.1",
    "@bimproject/country": "0.0.0",
    "@bimproject/fenv": "0.0.0",
    "@bimproject/language": "0.0.0",
    "@bimproject/t9n": "0.0.0",
    "@monaco-editor/react": "4.7.0",
    "@react-hook/resize-observer": "2.0.2",
    "axios": "1.13.6",
    "color": "5.0.3",
    "country-flag-icons": "1.6.15",
    "dayjs": "1.11.20",
    "graphql": "16.13.1",
    "i18next": "25.10.5",
    "i18next-locize-backend": "9.0.1",
    "immer": "11.1.4",
    "mousetrap": "1.6.5",
    "react": "18.3.1",
    "react-dom": "18.3.1",
    "react-helmet": "6.1.0",
    "react-i18next": "16.6.2",
    "react-icons": "5.6.0",
    "react-router": "7.13.2",
    "react-select": "5.10.2",
    "styled-components": "6.3.12",
    "usehooks-ts": "3.1.1",
    "xlsx": "^0.20.3",
    "yaml": "2.8.3"
  }
}
